import { URLParamsModel } from "@bt/core";


export class DomainPostRequest {
  public id: string;
  public name: string;
  public link: string;
  public description: string;
  public deleted: boolean;
  public publicKey: string;
  public type: number;
  public n: number;
  public blackout: number;
  public selected: boolean;
  public monetization: number;
  isopenuTMForUrl: boolean;
  isopentokensForUrl: boolean;
  utmForUrl:URLParamsModel[];
  tokensForUrl:URLParamsModel[];
  blackoutMsg:string;
  blackoutLiveSec : number;
  geoId: number;
  geoStr: string;
}




// WEBPACK FOOTER //
// ./src/app/core/requests/domain.postrequest.ts